import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import HorizontalSlider from '../HorizontalSlider';
import InventoryProvider from '../InventoryProvider';
import { ProductListViewItemByAlgolia } from '../ProductListViewItemByAlgolia';
import SkeletonItems from './SkeletonItems';
import { ProductReadModel } from '~types/api';

const ProductSlider: React.FC<{
  isLoading?: boolean;
  title?: string;
  title2?: string;
  products?: ProductReadModel[];
  listPath?: string;
}> = ({ isLoading, title, title2, products, listPath }) => {
  if (isLoading) {
    return <SkeletonItems />;
  }
  if (!products?.length) {
    return null;
  }
  return (
    <InventoryProvider productIds={products.map((product) => product.id!)}>
      <Container>
        <div className="d-flex justify-content-between align-items-end mb-3">
          <div>
            {title2 && <span className="text-black-50">{title}</span>}
            <h5 className="font-weight-bold mb-0">{title2 ?? title}</h5>
          </div>
          {listPath && (
            <Link style={{ textDecoration: 'underline' }} to={listPath}>
              もっと見る
            </Link>
          )}
        </div>
        <HorizontalSlider xs={2}>
          {products.map((product, i) => (
            <ProductListViewItemByAlgolia
              key={product!.id}
              productJson={product!}
              index={i}
              col={false}
              border
            />
          ))}
        </HorizontalSlider>
      </Container>
    </InventoryProvider>
  );
};

export default ProductSlider;
